import {defineMessage} from 'react-intl'

export const BENEFITS_1_ROW1 = defineMessage({
    id: 'benefits_1_row1',
    defaultMessage: 'Comfortable'
})

export const BENEFITS_1_ROW2 = defineMessage({
    id: 'benefits_1_row2',
    defaultMessage: 'to wear'
})

export const BENEFITS_2_ROW1 = defineMessage({
    id: 'benefits_2_row1',
    defaultMessage: 'Many'
})

export const BENEFITS_2_ROW2 = defineMessage({
    id: 'benefits_2_row2',
    defaultMessage: 'use cases'
})

export const BENEFITS_3_ROW1 = defineMessage({
    id: 'benefits_3_row1',
    defaultMessage: 'Fast'
})

export const BENEFITS_3_ROW2 = defineMessage({
    id: 'benefits_3_row2',
    defaultMessage: 'support'
})

export const BENEFITS_4_ROW1 = defineMessage({
    id: 'benefits_4_row1',
    defaultMessage: 'Premium'
})

export const BENEFITS_4_ROW2 = defineMessage({
    id: 'benefits_4_row2',
    defaultMessage: 'Design'
})
